export const OMIT_FIELDS = [
  // omit fields that we fill in automatically
  'project',
  'issuetype',
  'summary',
  'reporter', // TODO confirm this, assume it should be set to the authed user?

  // omitting these for now
  'issuerestriction',
  'timetracking',
];
